import useAuth from '@app/auth/use-auth';
import AverageCarbonIntensity from '../components/average-carbon-intensity';
import NumberProductAndIngredients from '../components/number-products-and-ingredients';
import ProductsStatusBreakdown from '../components/products-status-breakdown';
import { useProductDashboard } from '../product-dashboard-page';

const ProductDashboardHeader = () => {
  const { user } = useAuth();
  const {
    averageProductEmissionsPerKg,
    totalNumberOfProducts,
    numberIngredients,
    numberProductsDraft,
    numberProductsEditing,
    numberProductsInProgress,
    numberProductsComplete,
  } = useProductDashboard();
  return (
    <div className="mt-4 w-full items-center justify-between space-y-4 sm:flex sm:flex-col md:flex md:flex-row md:items-end md:space-x-4">
      <div className="flex size-full flex-col rounded-lg sm:flex-row">
        <AverageCarbonIntensity
          averageEmissionsPerKg={averageProductEmissionsPerKg}
        />
        <NumberProductAndIngredients
          numProducts={totalNumberOfProducts}
          numIngredients={numberIngredients}
        />
      </div>
      {user!.productCategory === 'product' && (
        <ProductsStatusBreakdown
          calculating={numberProductsInProgress}
          draft={numberProductsDraft}
          complete={numberProductsComplete}
          editing={numberProductsEditing}
        />
      )}
    </div>
  );
};

export default ProductDashboardHeader;
